import { AlertTriangle, CalendarClock, FileText, ReceiptText } from "lucide-react";
import type { Invoice } from "@/lib/invoice.api";
import {
  DocumentKpiCard,
  money,
} from "@/pages/documents/components/DocumentWorkspace";
import type { InvoiceMetrics } from "../invoice-calculations";
import { formatInvoiceAge, getInvoiceLabel } from "../invoice-formatters";

interface InvoiceStatsGridProps {
  invoicesCount: number;
  metrics: InvoiceMetrics;
  latest?: Invoice;
  loading: boolean;
}

export function InvoiceStatsGrid({
  invoicesCount,
  metrics,
  latest,
  loading,
}: InvoiceStatsGridProps) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <DocumentKpiCard
        label="Factures"
        value={loading ? "..." : String(invoicesCount)}
        detail={`${metrics.openCount} ouverte${metrics.openCount > 1 ? "s" : ""}`}
        icon={FileText}
        tone="gold"
      />
      <DocumentKpiCard
        label="Valeur facturée"
        value={loading ? "..." : money(metrics.totalValue)}
        detail="Toutes factures listées"
        icon={ReceiptText}
        tone="success"
      />
      <DocumentKpiCard
        label="À surveiller"
        value={loading ? "..." : String(metrics.overdueCount)}
        detail="Factures émises en retard"
        icon={AlertTriangle}
        tone={metrics.overdueCount > 0 ? "danger" : "neutral"}
      />
      <DocumentKpiCard
        label="Dernière facture"
        value={latest ? getInvoiceLabel(latest) : "-"}
        detail={
          latest
            ? `${latest.partySnapshot?.fullName ?? "Client"} / ${formatInvoiceAge(latest.createdAt)}`
            : "Aucune facture"
        }
        icon={CalendarClock}
        tone="neutral"
      />
    </div>
  );
}
